import React from "react";
import s from "./styles.module.scss";

const TermsOfService = () => {
  return (
    <div className={s.legalPageContainer}>
      <div className={s.boxContent}>
        <div className={s.legalContent}>
          <h1 className={s.legalTitle}>Terms of Service</h1>
          <p className={s.legalEffectiveDate}>
            <strong>Effective Date:</strong> November 30th, 2025
          </p>

          <p className={s.legalIntro}>
            Welcome to Ocean ("we," "us," or "our"). These Terms of Service
            ("Terms") govern your use of the Ocean web application ("Service" or
            "Ocean"). By accessing or using Ocean, you agree to be bound by
            these Terms. If you do not agree, please do not use the Service.
          </p>

          <div className={s.legalSection}>
            <h2>1. Description of Service</h2>
            <p>
              Ocean is a web-based productivity tool that helps students
              organize their academic schedules by extracting important events
              (such as classes, assignments, and exams) from uploaded syllabi
              and syncing them to their personal calendars (Google, Outlook, or
              Apple).
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>2. Eligibility</h2>
            <p>To use Ocean, you must:</p>
            <ul>
              <li>
                Be at least 13 years old (or have parental/guardian consent if
                under 18).
              </li>
              <li>Have the legal capacity to agree to these Terms.</li>
            </ul>
          </div>

          <div className={s.legalSection}>
            <h2>3. User Responsibilities</h2>
            <p>By using Ocean, you agree that:</p>
            <ul>
              <li>
                You will only upload syllabi or course materials that you have
                permission to share.
              </li>
              <li>You will not upload harmful, illegal, or malicious files.</li>
              <li>
                You will not misuse the Service, attempt unauthorized access, or
                disrupt its operation.
              </li>
            </ul>
          </div>

          <div className={s.legalSection}>
            <h2>4. Intellectual Property</h2>
            <p>
              All content, code, design, and trademarks associated with Ocean
              are the property of Ocean (or its creators) unless otherwise
              specified. You retain ownership of the syllabi or files you
              upload.
            </p>
            <p>
              You may not reproduce, distribute, or create derivative works from
              Ocean's platform without prior written permission.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>5. Data Ownership & Continuity</h2>
            <p>
              Users retain full ownership and control of all data they 
              upload to or generate within Ocean (“User Data”). 
              Ocean does not claim any ownership rights over User Data. 
              Users may export or delete their User Data at any 
              time by contacting support. These rights survive 
              termination of the service. In the event of an acquisition, restructuring, or bankruptcy, 
              Ocean will ensure that users continue to have the ability to 
              access and export their User Data without interruption.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>6. Accuracy Disclaimer</h2>
            <p>
              While Ocean strives to accurately extract dates and events, we do
              not guarantee the correctness or completeness of the data
              provided.
            </p>
            <p>
              You are responsible for verifying that any calendar events or
              deadlines created through Ocean are accurate and applicable to
              your personal academic schedule.
            </p>
            <p>
              We are not liable for any missed deadlines, inaccuracies, or
              damages resulting from use of the Service.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>7. Account and Data Management</h2>
            <p>
              If you create an account, you are responsible for maintaining the
              confidentiality of your login credentials.
            </p>
            <p>
              You may request the deletion of your account and associated data
              at any time by contacting{" "}
              <a href="mailto:info@oceanwebapp.com">info@oceanwebapp.com</a>.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>8. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to Ocean
              at any time, with or without notice, if you violate these Terms or
              misuse the Service.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless Ocean, its
              owners, affiliates, and team members from and against any claims,
              damages, liabilities, losses, costs, or expenses (including
              reasonable attorney fees) arising out of or related to:
            </p>
            <ul>
              <li>Your use of the Service;</li>
              <li>Your violation of these Terms;</li>
              <li>
                Your violation of any third-party rights, including intellectual
                property or privacy rights.
              </li>
            </ul>
            <p>
              This indemnification obligation survives the termination of these
              Terms and your use of the Service.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>10. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Ocean and its owners,
              affiliates, and team members shall not be liable for any indirect,
              incidental, consequential, special, or punitive damages, including
              but not limited to loss of profits, data, or goodwill, arising out
              of or related to your use of the Service, even if we have been
              advised of the possibility of such damages.
            </p>
            <p>
              Our total liability for any claim arising from or related to these
              Terms or your use of the Service shall not exceed the amount you
              have paid us, if any, for using the Service in the past twelve
              (12) months.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>11. Governing Law</h2>
            <p>
              These Terms and any related disputes shall be governed by and
              construed in accordance with the laws of the United States,
              without regard to conflict of law principles.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>12. Beta Disclaimer</h2>
            <p>
              You acknowledge and agree that Ocean is currently offered as a
              beta version and may contain bugs, errors, or other issues. We do
              not guarantee the availability, reliability, or accuracy of the
              Service during the beta period, and we are not liable for any
              damages or losses arising from its use.
            </p>
          </div>
          
          <div className={s.legalSection}>
            <h2>13. Accessibility Commitment</h2>
            <p>
            Ocean will achieve and maintain substantial conformance with the Web Content Accessibility Guidelines (**WCAG**) 2.1 Level AA no later than eighteen (18) months after the Effective Date. 
            Ocean will remediate reported accessibility defects in a commercially reasonable timeframe.
            </p>

          </div>

          <div className={s.legalSection}>
            <h2>14. Changes to the Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Material
              changes will be communicated by updating the "Effective Date" at
              the top of this page.
            </p>
            <p>
              Your continued use of Ocean after changes are posted constitutes
              your acceptance of the updated Terms.
            </p>
          </div>

          <div className={s.legalSection}>
            <h2>15. Contact Us</h2>
            <p>
              If you have any questions or concerns about these Terms, please
              contact us at:
            </p>
            <p>
              <a href="mailto:info@oceanwebapp.com">info@oceanwebapp.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
